import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import type { SearchModeType } from '@core/Areas/Search/types'

const initialState: SearchState = {
  prevSportsSearchTerms: [],
  prevRacingSearchTerms: [],
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    addSearchTermToPrevious(
      state,
      { payload }: PayloadAction<{ type: SearchModeType; searchTerm: string }>
    ) {
      if (payload.type === 'racing' && !state.prevRacingSearchTerms.includes(payload.searchTerm)) {
        state.prevRacingSearchTerms.unshift(payload.searchTerm)
        state.prevRacingSearchTerms.splice(10)
      }
      if (payload.type === 'sports' && !state.prevSportsSearchTerms.includes(payload.searchTerm)) {
        state.prevSportsSearchTerms.unshift(payload.searchTerm)
        state.prevRacingSearchTerms.splice(10)
      }
    },

    clearAllPreviousSearchTerms(state, { payload }: PayloadAction<{ type: SearchModeType }>) {
      if (payload.type === 'racing') {
        state.prevRacingSearchTerms = []
      }
      if (payload.type === 'sports') {
        state.prevSportsSearchTerms = []
      }
    },

    removeSearchTermFromPrevious(
      state,
      { payload }: PayloadAction<{ type: SearchModeType; searchTerm: string }>
    ) {
      if (payload.type === 'racing') {
        state.prevRacingSearchTerms = state.prevRacingSearchTerms.filter(
          term => term !== payload.searchTerm
        )
      }
      if (payload.type === 'sports') {
        state.prevSportsSearchTerms = state.prevSportsSearchTerms.filter(
          term => term !== payload.searchTerm
        )
      }
    },
  },
})

export const {
  addSearchTermToPrevious,
  clearAllPreviousSearchTerms,
  removeSearchTermFromPrevious,
} = searchSlice.actions

export default persistReducer(
  {
    key: 'search',
    storage,
    // debug: !PRODUCTION,
  },
  searchSlice.reducer
)

// =====
// Types
// =====

type SearchState = {
  prevSportsSearchTerms: string[]
  prevRacingSearchTerms: string[]
}
